import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { GasLandingPage, GasLandingPageProps } from "./GasLandingPage";

export const EMPTY_PAGE_CONTENT: GasLandingPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/gas";

export const GasLandingPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<GasLandingPageProps>("gas_services_landing_page", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <GasLandingPage {...routeProps} {...content} />;
};
